import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import calendar from "dayjs/plugin/calendar";
import customParseFormat from "dayjs/plugin/customParseFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";

dayjs.extend(calendar);
dayjs.extend(customParseFormat);
dayjs.extend(utc);

dayjs.locale("pt-br");
dayjs.extend(relativeTime);

export { default as dayjs } from "dayjs";
